import { render, staticRenderFns } from "./ModalDeleteKpi.vue?vue&type=template&id=06e19a9e&"
import script from "./ModalDeleteKpi.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports